import translationKeys from '../translationKeys'

export default {
  [translationKeys.GO_TO_SEARCH_TO_GET_STARTED]: 'Go to search to get started',
  [translationKeys.YOU_ARE_MISSING_OUT]: 'You are missing out!',
  [translationKeys.YOU_HAVE_NO_ALERTS_SET_UP]:
    // eslint-disable-next-line max-len
    'You have no alerts set up which means you are missing out on real-time updates from our dynamic database. You can set up alerts from your search results, profiles, or your custom lists.',
  [translationKeys.FOR_EXAMPLE]: 'For example:',
  [translationKeys.TRACK_WHEN_ASSETS_CHANGE]: 'Track when assets change phase or indication.',
  [translationKeys.FIND_OUT_WHICH_EVENT]: 'Find out which event you can meet a company at next.',
  [translationKeys.GOOD_THINGS_COME]: 'Good things come to those who wait!',
  [translationKeys.THERE_ARE_NO_UPDATES]:
    // eslint-disable-next-line max-len
    'There are no updates to your alerts today, but do not worry our dynamic database is updated from over 25 annual events so it will not be long.',
  [translationKeys.IN_THE_MEANTIME]:
    // eslint-disable-next-line max-len
    'In the meantime, have you explored all the options available? You can set up alerts on profiles or your custom lists.',
  [translationKeys.TO]: 'to',
  [translationKeys.TO_INCLUDE]: 'to include',
  [translationKeys.MORE]: '+ more',
  [translationKeys.CORPORATE_HISTORY]: 'Corporate history',
  [translationKeys.REGISTERED_FOR]: 'Registered for',
  [translationKeys.UPDATED_WITH]: 'updated with',
  [translationKeys.ADDED]: 'Added',
  [translationKeys.NEW_ASSET]: 'new asset',
  [translationKeys.NEW_ASSETS]: 'new assets',
  [translationKeys.CHANGED]: 'Changed',
}
